export const basePriceChangeConstants = {
	GetDateList: {
		SUCCESS : 'GET_LIST_WITH_DATES_SUCCESS',
		REQUEST : 'GET_LIST_WITH_DATES_REQUEST',
		FAILURE : 'GET_LIST_WITH_DATES_FAILURE'
	},
	GetPaged: {
		SUCCESS : 'GET_PAGED_PRICE_CHANGE_MATERIALS_LIST_SUCCESS',
		REQUEST : 'GET_PAGED_PRICE_CHANGE_MATERIALS_LIST_REQUEST',
		FAILURE : 'GET_PAGED_PRICE_CHANGE_MATERIALS_LIST_FAILURE'

	},
	Create: {
		SUCCESS : 'CREATE_PRICE_CHANGE_SUCCESS',
		REQUEST : 'CREATE_PRICE_CHANGE_REQUEST',
		FAILURE : 'CREATE_PRICE_CHANGE_FAILURE'
	},
	Delete: {
		SUCCESS : 'DELETE_PRICE_CHANGE_SUCCESS',
		REQUEST : 'DELETE_PRICE_CHANGE_REQUEST',
		FAILURE : 'DELETE_PRICE_CHANGE_FAILURE'
	},
	Upload: {
		SUCCESS : 'UPLOAD_PRICE_CHANGE_FILE_SUCCESS',
		REQUEST : 'UPLOAD_PRICE_CHANGE_FILE_REQUEST',
		FAILURE : 'UPLOAD_PRICE_CHANGE_FILE_FAILURE'
	},
	GetExampleFile: {
		SUCCESS : 'GET_EXAMPLE_FILE_SUCCESS',
		REQUEST : 'GET_EXAMPLE_FILE_REQUEST',
		FAILURE : 'GET_EXAMPLE_FILE_FAILURE'
	},
	CLEAR: 'BASE_PRICE_CHANGE_MATERIALS_CLEAR'
}